export enum UserRole {
	OWNER = 'owner',
	ASSISTANT = 'assistant',
	PARTNER = 'partner',
	CUSTOMER = 'customer',
	MEMBER = 'member'
}
